import { render, staticRenderFns } from "./InternDeprecated.vue?vue&type=template&id=ab49a524&scoped=true"
import script from "./InternDeprecated.vue?vue&type=script&lang=js"
export * from "./InternDeprecated.vue?vue&type=script&lang=js"
import style0 from "./InternDeprecated.vue?vue&type=style&index=0&id=ab49a524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab49a524",
  null
  
)

export default component.exports